const PERSON_STATE = {
  NewlyAdded: 'Newly added',
  Removed: 'Removed',
  RIF: 'RIF',
  Moved: 'Moved',
  Edited: 'Edited',
  RemovedManager: 'Removed manager',
  NewReport: 'New Report',
  RemovedReport: 'Removed Report',
  Benched: 'Benched',
  Exited: 'Exited',
  Closed: 'Closed',
  ScenarioRefreshMissing: 'Scenario Refresh - Missing from Main Org',
  ScenarioRefreshAdded: 'Scenario Refresh - Added from Main Org',
  Backfill: 'Backfill'
}

export const PERSON_STATE_ORDER = {
  [PERSON_STATE.NewlyAdded]: 0,
  [PERSON_STATE.Moved]: 1,
  [PERSON_STATE.Edited]: 2,
  [PERSON_STATE.RIF]: 3,
  [PERSON_STATE.Backfill]: 4
}

export const SPECIAL_STATES = [
  PERSON_STATE.RIF,
  PERSON_STATE.Exited,
  PERSON_STATE.NewlyAdded,
  PERSON_STATE.Closed,
  PERSON_STATE.ScenarioRefreshMissing,
  PERSON_STATE.ScenarioRefreshAdded,
  PERSON_STATE.Backfill
]

export const XEROX_MAIN_BOARDS = ['bd_qylw4KBNweawJmlDKxTPbd', 'bd_DT9ONl8ZEjgOOwxFcVzKc']

export default PERSON_STATE
